<app-search></app-search>
<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      <h1 class="title">Lista de fuentes de financiación</h1>
    </div>
    <br />
    <div class="card-header">
      <button
        id=""
        class="primary-button"
        appPermision="/sourcefounding+c"
        (click)="createSourcefounding()"
      >
        <span class="button-content"> <mat-icon>add_circle</mat-icon> Agregar nuevo </span>
      </button>
    </div>
    <br />
    <div class="table-scroll-wrapper">
      <section class="table-container mat-elevation-z1" tabindex="0">
        <div class="table-adjustable">
          <table
            mat-table
            [dataSource]="
              (asyncfoundingsources | async) ?? []
                | paginate
                  : {
                      id: 'server',
                      itemsPerPage: limit,
                      currentPage: page,
                      totalItems: total,
                    }
            "
          >
            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let sourcefounding">
                <div class="action-buttons">
                  <a
                    title="Editar"
                    class="icon-button"
                    appPermision="/sourcefounding+u"
                    (click)="updateSourcefounding(sourcefounding)"
                  >
                    <span class="material-symbols-outlined"><mat-icon>edit</mat-icon></span>
                  </a>
                  <a
                    appOnlysuperuser="/sourcefounding"
                    (click)="eliminate(sourcefounding)"
                    class="icon-button"
                  >
                    <span class="material-symbols-outlined"><mat-icon>delete</mat-icon></span>
                  </a>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let sourcefounding">
                {{ sourcefounding.id }}
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Nombre</th>
              <td mat-cell *matCellDef="let sourcefounding">
                {{ sourcefounding.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef>Descripción</th>
              <td mat-cell *matCellDef="let sourcefounding">
                {{ sourcefounding.description }}
              </td>
            </ng-container>

            <ng-container matColumnDef="term">
              <th mat-header-cell *matHeaderCellDef>Periodo</th>
              <td mat-cell *matCellDef="let sourcefounding">
                {{ sourcefounding.term }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: showColumns" class="highlight-row"></tr>
          </table>
        </div>
      </section>
    </div>
    <pagination-controls
      (pageChange)="fetchSourcefounding($event)"
      previousLabel="Anterior"
      nextLabel="Siguiente"
      id="server"
    ></pagination-controls>
  </div>
</div>
